export default __webpack_public_path__ + "static/media/slider_arrow.9cdbb0d3.png";